import { Env, readFromEnv } from '@cinch-nx/environments'
import { useEffect, useState } from 'react'

import { CookieConsentPreference } from '../cookie-consent.types'
import {
  getCookieConsentPreferences,
  hasCookieConsentBeenSet,
  setCookieConsentPreferences,
} from '../utils/cookies'

const getDefaultCookiePreferences = (): CookieConsentPreference => {
  const showNewCookieCategories =
    readFromEnv(Env.ShowNewCookieCategories)?.toLowerCase() === 'true'
  return {
    advertising: false,
    analytics: showNewCookieCategories,
    functional: false,
  }
}

export function useCookiePreferences(setLoaded?: (arg: boolean) => void) {
  const defaultCookiePreferences = getDefaultCookiePreferences()

  const [cookiePreferences, setCookiePreferencesState] =
    useState<CookieConsentPreference>(defaultCookiePreferences)

  useEffect(() => {
    const cookie = getCookieConsentPreferences()
    if (cookie) {
      setCookiePreferencesState(cookie)
    } else {
      setCookiePreferencesState(defaultCookiePreferences)
    }

    setLoaded?.(true)
  }, [])

  const setCookiePreferences = (state: CookieConsentPreference) => {
    setCookiePreferencesState(state)
    setCookieConsentPreferences(state)
  }

  return {
    cookiePreferences: cookiePreferences as CookieConsentPreference,
    setCookiePreferences,
    isCookieConsentSet: hasCookieConsentBeenSet(),
  }
}
